import _ from "lodash";
import { queue } from "./promise";
import { Principal } from "@codeArt/auth";

export function pipeline(targets, evt){
  //依次验证多个对象，每个对象会有验证结果，如果所有对象都没有通过验证，那么触发evt.error
  if (targets.length === 0) return true;
  evt = evt || {};
  let {before, success, error} = evt;
  if (before) before();

  let auther = Principal.getAuther();

  let features = targets.map((target, i) => {
    return new Promise((resolve, reject) => {
      auther.verify(target).then(({allow})=>{
        target.allow = allow;
        resolve();
      }).catch(reject);
    });
  });

  queue(features).then(() => {
    if (_.find(targets, t => t.allow)) {
      success(targets);
    } else {
      error();
    }
  });
}
